import CitySEOHead from "@/components/feature/CitySEOHead";
import AmesHeroSection from "./components/HeroSection";
import AmesStickyNav from "./components/StickyNav";
import AmesProcessingTimeSection from "./components/ProcessingTimeSection";
import AmesServicesSection from "./components/ServicesSection";
import AmesLocalAreaSection from "./components/LocalAreaSection";
import AmesTestimonialsSection from "./components/TestimonialsSection";
import AmesAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import AmesComparisonSection from "./components/ComparisonSection";
import AmesMistakesSection from "./components/MistakesSection";
import AmesHowItWorksSection from "./components/HowItWorksSection";
import AmesFAQSection, { faqs } from "./components/FAQSection";
import AmesHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import AmesFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const amesFaqs = faqs as { q: string; a: string }[];

const amesServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens." },
  { name: "New Passport", description: "First-time passport application assistance." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service." },
  { name: "Child Passport", description: "Passport services for minors under 16." },
  { name: "Name Change", description: "Passport correction and name change service." },
  { name: "Second Passport & Damaged", description: "Second passport issuance and damaged passport replacement." },
];

export default function AmesPage() {
  return (
    <>
      <CitySEOHead
        city="Ames"
        state="Iowa"
        stateAbbr="IA"
        route="/cities/ames"
        title="Emergency Passport Ames, IA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Ames, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Iowa State University students, Story County professionals, and central Iowa families."
        geoPlacename="Ames, Iowa"
        geoPosition="42.0347;-93.6200"
        faqs={amesFaqs}
        servicesSchema={amesServices}
        statePageName="Iowa"
        statePageRoute="/states/iowa"
      />
      <div className="font-sans">
        <AmesHeroSection />
        <AmesStickyNav />
        <AmesProcessingTimeSection />
        <AmesLocalAreaSection />
        <AmesServicesSection />
        <AmesTestimonialsSection />
        <AmesAcceptanceFacilitiesSection />
        <AmesComparisonSection />
        <AmesMistakesSection />
        <AmesHowItWorksSection />
        <AmesFAQSection />
        <AmesHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/ames" state="IA" />
        <AmesFinalCTA />
      </div>
    </>
  );
}